module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Keyboard-cc1df2e2e2768e0ad538b0e356d5df7e.svg";